// Entry file for JS
// Custom components
import { Accordion } from './components/accordion';
import { AddToCalendar } from './components/add-to-calendar';
import {Autosuggest} from './components/autosuggest';
import { BackButton } from './components/backbutton';
import { ComboBox } from './components/combo-box';
import { Draggable } from './components/draggable';
import { ExpandFaq } from './components/expand-faq';
import { ExpandRichText } from './components/expand-rich-text';
import { FormHandler } from './components/form';
import { HighlightListHeight } from './components/highlight-list-height';
import { ImageGallery } from './components/image-gallery';
import { Navigation } from './components/navigation';
import { Notification } from './components/notification';
import { LazyloadBoards } from './components/lazyload-boards';
import { PersonSlider } from './components/person-slider';
import { Podcast } from './components/podcast';
import {SearchJobcount} from './components/search-jobcount';
import { Sticky } from './components/sticky';
import { Tabsmenu } from './components/tabsmenu';
import { Textarea } from './components/textarea';
import { Video } from './components/video';
import { Goodhabitz } from './components/goodhabitz';

import { ScrollToAnchor } from './components/scroll-to-anchor';

// Analytics
import { Analytics } from './helpers/analytics';

const components = [
	Accordion,
	AddToCalendar,
	Autosuggest,
	BackButton,
	ComboBox,
	Draggable,
	ExpandFaq,
	ExpandRichText,
	FormHandler,
	HighlightListHeight,
	ImageGallery,
	LazyloadBoards,
	PersonSlider,
	Podcast,
    Navigation,
	Notification,
	SearchJobcount,
	Sticky,
	Tabsmenu,
	Textarea,
	Video,
	Goodhabitz //@TODO: Use Goodhabitz as dynamic import because it's used with BMC aswell
];

const createComponents = () => {
    for (let i = 0; i < components.length; i = i + 1) {
        const componentsList = document.querySelectorAll(components[i].getSelector());

        if (componentsList.length) {
            for (const component of componentsList) {
                const componentDataString = component.getAttribute('data-component');
				const componentDataJson = componentDataString ? JSON.parse(componentDataString) : null;
				const componentData = componentDataJson ? componentDataJson[components[i].name] : undefined;
				new components[i](component, componentData);
            }
        }
    }
};

if(!window.Analytics) window.Analytics = new Analytics();
window.ScrollToAnchor = new ScrollToAnchor();

if(typeof Symbol === 'undefined' || !NodeList.prototype[Symbol.iterator]) {
    const polyfill = document.createElement('script');
    polyfill.src = `${window.yacht.jsPath}/babel-polyfill.min.js`;
    polyfill.onload = createComponents;
    document.body.appendChild(polyfill);
} else {
    createComponents();
}
